import { LayoutModule } from '../../../layout/modules';
import { PqrHistoryFilters } from './filters';
import { useState } from 'react';
import { PqrFilter } from '../../../../shared/types/modules/pqr';
import { PqrHistoryList } from './list';

export const PqrHistory = () => {
    const [filters, setFilters] = useState<PqrFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de históricos de casos PQR">
                <PqrHistoryFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <PqrHistoryList filters={filters} />
        </>
    );
};
